module.exports = __webpack_public_path__ + "static/media/gbx.39e91193.svg";